/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React from 'react';
import * as H from 'history';
import { ForgotPasswordModel, RequestState } from '../../../models/components/ForgotPasswordModel';
import { ViewModel } from '../../../core/viewmodel/ViewModel';
import { SnackbarStore } from '../../../stores/application/SnackbarStore';
import { LoginStore } from '../../../stores/components/LoginStore';
import { StoreProvider } from '../../../stores/StoreProvider';
import { ResetPasswordService } from '../../../services/ResetPasswordService';
import { Pages } from '../../../navigation/Pages';

export class ForgotPasswordFormViewModel extends ViewModel {
	private forgotPasswordModel: ForgotPasswordModel = new ForgotPasswordModel();
	private readonly snackbarStore: SnackbarStore;
	private readonly loginStore: LoginStore;
	private readonly resetService: ResetPasswordService;

	constructor(storeProvider: StoreProvider, history: H.History) {
		super(storeProvider, history);
		this.loginStore = storeProvider.loginStore;
		this.snackbarStore = storeProvider.snackbarStore;
		this.resetService = storeProvider.resetPasswordService;
	}

	public isLoading(): boolean {
		return this.forgotPasswordModel.state === RequestState.LOADING;
	}

	public getEMail(): string {
		return this.forgotPasswordModel.email;
	}

	public setEMail(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
		this.forgotPasswordModel.setEmail(e.target.value);
	}

	public disableRequestButton(): boolean {
		return this.forgotPasswordModel.email === '';
	}

	public cancel = (): void => {
		this.navigateTo(Pages.REQUEST_LOGIN);
	};

	public requestReset(): void {
		this.forgotPasswordModel.setState(RequestState.LOADING);

		const email = this.getEMail();
		this.forgotPasswordModel.setEmail('');
		this.resetService
			.forgotPassword(email)
			.then(() => {
				this.snackbarStore.showSuccess('resetPassword.success');
				this.cancel();
				this.forgotPasswordModel.setState(RequestState.INIT);
			})
			.catch((error) => {
				if (error.message === 'Network Error') {
					this.snackbarStore.showError('application.network_error');
				} else {
					this.snackbarStore.showSuccess('resetPassword.success');
				}
				this.forgotPasswordModel.setState(RequestState.INIT);
			});
	}
}
